import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/map';

declare var ajaxurl:any;

@Injectable()
export class RecordService {

  constructor(private http:Http) {
  }

  /**
   * Get all records by post.
   *
   * @param postId
   * @returns {any}
   */
  getRecords(postId:any) {
    let params:URLSearchParams = new URLSearchParams();
    params.set('action', 'get_records');
    params.set('post_id', postId);

    return this.http
      .get(ajaxurl, {
        search: params
      })
      .map((res:Response) => res.json());
  }

  /**
   * Upload audio record.
   *
   * @param formData
   * @param postId
   * @returns {any}
   */
  postRecordUpload(formData:FormData, postId:any) {

    return this.http
      .post(`${ajaxurl}?action=post_upload_record`, formData, this.getTokenPostOptions())
      .map((res:Response) => res.json());
  }

  /**
   * Post all records.
   *
   * @param records
   * @param postId
   * @returns {any}
   */
  postRecords(records:any, postId:any) {
    let params:URLSearchParams = new URLSearchParams();

    let idRecords:any = [];
    records.forEach((value:any) => {
      idRecords.push(value.id);
    });

    params.set('records', JSON.stringify(idRecords));
    params.set('post_id', postId);

    return this.http
      .post(`${ajaxurl}?action=post_upload_records`, params, this.getTokenPostOptions())
      .map((res:Response) => res.json());
  }

  /**
   * Post update single record.
   *
   * @param record
   * @param postId
   * @returns {any}
   */
  postUpdateRecord(record:any, postId:any) {
    let params:URLSearchParams = new URLSearchParams();
    params.set('record', JSON.stringify(record));
    params.set('post_id', postId);

    return this.http
      .post(`${ajaxurl}?action=post_update_record`, params, this.getTokenPostOptions())
      .map((res:Response) => res.json());
  }

  /**
   * Change token request.
   *
   * @returns {RequestOptions}
   */
  private getTokenPostOptions():RequestOptions {

    let headers = new Headers();
    headers.set('Accept', 'application/json');
    let options = new RequestOptions({
      headers: headers
    });

    return options;
  }

  /**
   * Remove record from post.
   *
   * @param postId
   * @param recordId
   * @returns {any}
   */
  getRemoveRecord(postId:any, recordId:any) {
    let params:URLSearchParams = new URLSearchParams();
    params.set('action', 'get_remove_record');
    params.set('post_id', postId);
    params.set('record_id', recordId);

    return this.http
      .get(ajaxurl, {
        search: params
      })
      .map((res:Response) => res.json());
  }

}


// WEBPACK FOOTER //
// ./admin/src/app/components/record/record.service.ts